<template>
  <v-btn
    :color="getColor()"
    class="text-none"
    :class="getCssClass()"
    :type="type"
    :title="title"
    :outlined="outlined"
    :text="text"
    :small="small"
    :disabled="disabled"
    :icon="icon"
    :ripple="false"
    @click="$emit('click')"
  >
    <slot />
  </v-btn>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: "secondary"
    },
    cssClass: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "button"
    },
    outlined: {
      type: Boolean,
      default: false
    },
    text: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ""
    },
    small: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    icon: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getCssClass() {
      return this.isPrimaryButton()
        ? `${this.cssClass} white--text`
        : this.cssClass;
    },
    getColor() {
      return this.isPrimaryButton() ? "btn-primary" : this.color;
    },
    isPrimaryButton() {
      return this.color === "primary";
    }
  }
};
</script>
